// extracted by mini-css-extract-plugin
export var linkText = "_o3-0";